module.exports = __webpack_public_path__ + "static/img/list_en.b3f41e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list_en.png
// module id = 8PvQ
// module chunks = 1